import type { Commonv1Value } from '@/generated/hooks/grimoire/models';
import type { TAopViewLocationState } from '@/modules/aop-map/aop-view-state';

/**
 * Router state for "Run again": the repeated run's inputs, which the pre-run
 * page prefills for review instead of running straight away.
 */
export type TRunAgainLocationState = TAopViewLocationState & {
  runAgainInputs?: Record<string, Commonv1Value>;
};

/**
 * The inputs of the run being repeated, if the page was reached from "Run again".
 *
 * @param state - `location.state`, which any page may have set to anything
 * @returns The previous run's inputs, or undefined when there are none
 */
export function runAgainInputsFrom(
  state: unknown,
): Record<string, Commonv1Value> | undefined {
  if (typeof state !== 'object' || state === null) return undefined;
  const inputs = (state as TRunAgainLocationState).runAgainInputs;
  return inputs && Object.keys(inputs).length > 0 ? inputs : undefined;
}
